import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHome = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M409.6 1024h-256v-512h-153.6l512-512 512 512h-153.6v512h-256v-307.2h-204.8v307.2z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgHome);
export default ForwardRef;
